import { store } from '@/decorators/store';
import { Facility } from '@/entities/Facility';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'FacilityStore' })
export class FacilityStore extends AbstractEntityStore<Facility> {
  protected entityIdKey = 'id';
  protected entityValueKey = 'name';
}
